import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-confirmation-dialog',
  templateUrl: './confirmation-dialog.component.html',
  styleUrls: ['./confirmation-dialog.component.scss']
})
export class ConfirmationDialogComponent implements OnInit {

  cddReviewDate = new UntypedFormControl(new Date());
  isWarningNotification = false;
  fxBtnLayout = 'space-between center';
  enableWarningSign = false;
  isGeneralContentDisplay = false;
  comments;
  lendingEntityStatus: any;
  constructor(
    public dialogRef: MatDialogRef<ConfirmationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) { }

  ngOnInit() {
    console.log(this.data.content);
    if (this.data?.dialogType === 'warning') {
      this.isWarningNotification = true;
      this.fxBtnLayout = 'center center';
    } else if (this.data?.dialogType === 'comment') {
      this.isGeneralContentDisplay = true;
      this.fxBtnLayout = 'end';
    }
    this.enableWarningSign = (this.data?.dialogType === 'warning' || this.data?.dialogType === 'Warning with Submit');
    this.lendingEntityStatus = this.data?.lendingEntityStatus || null;
  }

  closeClicked(): void {
    this.dialogRef.close(false);
  }

  saveClicked(): void {
    let saveRespone: any = true;
    if (this.data?.includesCpList === 'approveCreditLimitFiComponent') {
      saveRespone = {
        result: true,
        lendingEntityStatus: this.lendingEntityStatus
      };
    }
    if (this.data.title === 'Mark CDD Review' && this.cddReviewDate.valid) {
      saveRespone = this.cddReviewDate.value;
    }
    if (this.data.calledFrom === 'termSheetPage') {
      saveRespone = this.comments ? this.comments : true;
    }
    if (this.data.v2Styles) {
      saveRespone = {
        result: true,
        comments: this.comments
      };
    }
    this.dialogRef.close(saveRespone);
  }

  getType(val) {
    return typeof val;
  }

  okayClicked(): void {
    this.dialogRef.close();
  }
}
